"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["favorites"] = "favorites";
  TranslationKey["mrp"] = "mrp";
  TranslationKey["mrpStatement"] = "mrpStatement";
  TranslationKey["notifyMe"] = "notifyMe";
  TranslationKey["quickBuy"] = "quickBuy";
  TranslationKey["regularPrice"] = "regularPrice";
  TranslationKey["subscriptionLabel"] = "subscriptionLabel";
  return TranslationKey;
}({});
